import { PersonJobType as PersonJobApiType } from 'src/api/generated/touring/types';
import { mapShowWithTourType } from '../common';
import { mapJobs } from './helpers';
import { PersonJobType } from './types';

export const mapPersonJobsType = (
  apiPersonJobs: PersonJobApiType
): PersonJobType => {
  return {
    showTypeMinified: mapShowWithTourType(apiPersonJobs.show),
    jobs: mapJobs(apiPersonJobs.jobs),
  };
};
